import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';


const Udaan2024 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_url: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url}/home/events-activities/school-programs/Udaan/1.webp`;
    const p2 = `${config.base_image_url}/home/events-activities/school-programs/Udaan/2.webp`;
    const p3 = `${config.base_image_url}/home/events-activities/school-programs/Udaan/3.webp`;
    const p4 = `${config.base_image_url}/home/events-activities/school-programs/Udaan/4.webp`;
    const p5 = `${config.base_image_url}/home/events-activities/school-programs/Udaan/5.webp`;
    const p6 = `${config.base_image_url}/home/events-activities/school-programs/Udaan/6.webp`;
    const p7 = `${config.base_image_url}/home/events-activities/school-programs/Udaan/7.webp`;
    const p8 = `${config.base_image_url}/home/events-activities/school-programs/Udaan/8.webp`;


    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1.5,
            cols: 1.5,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1.3,
            cols: 1,
        },

        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
        {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        },

        {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
        },

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    "Udaan 2024-25"
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                  Classes: 1 to 5               Date: 10 January 2025
                                </Typography>
                                {/* <Typography
                                    variant={'h6'}
                                    color={'primary'}
                                    align={'center'}
                                    fontWeight={'normal'}
                                ><br />
                                    “A joy that is shared is the joy that is doubled” Udaan, a festival of joy brings with itself the
                                    special message of hope, happiness and joy”<br />
                                </Typography> */}
                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                    "Udaan 2024-25", the school carnival at National Public School, Yeshwanthpur Bengaluru, unfolded with great enthusiasm on January 10, 2025. The event transformed the school grounds into a vibrant hub of activity, featuring diverse arenas for games, activities and performances. Students from grades 1-5, dressed in Udaan T-shirts, participated eagerly in the meticulously organised event, which was divided into two time-managed sessions to ensure maximum engagement.<br></br>
                                    The carnival's thoughtful layout, including Activity and Games Arenas, allowed students to explore various interests and showcase their talents. Highlights included inflatable games, stage shows and a special souvenir. Parents watched proudly as their children immersed themselves in the festivities, creating lasting memories and fostering a strong sense of community.
                                    <br></br>
                                    The success of "Udaan 2024-25" exemplified the school's commitment to holistic development, providing students with valuable experiences that will contribute to their personal growth and social skills.
                                    <br></br>

                                </Typography>

                            </Box>
                            {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                ‘Go confidently in the direction of your dreams. Live the life you have imagined.’ – Henry Thoreau
                                <br />

                            </Typography>
 */}

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box marginBottom={4}>
                            <Sidebar2024 />
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2022 />
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Udaan2024;